import React, { useEffect, useState, memo } from "react";
import API from "api.js";
import { base, s3base } from "api.js";
import ReactHtmlParser from 'react-html-parser';
import { Modal, Button, Table } from "react-bootstrap";
import { confirmAlert } from 'react-confirm-alert';
import { store } from 'store/index';
import { setAlert } from 'action/index.js';
import "assets/css/popup.css";
import TemplateDetectorModal from "components/PracticeMaterial/PopUps/TemplateDetectorModal";
import Content from "/public/images/popup-icons/Content.png";
import Pronunciation from "/public/images/popup-icons/pronoun.png";
import Fluency from "/public/images/popup-icons/checkboxGreen.png";
import BarFrequency from "/public/images/popup-icons/popupBar.png";
import Grammar from "/public/images/popup-icons/Grammar.png";
import Vocabulary from "/public/images/popup-icons/Vocabulary.png";
import FormIcon from "/public/images/popup-icons/Form.png";
import WaveformAudioPlayer from "components/Question/Speaking/WaveformAudioPlayer";
import PlaceHolderUser from "assets/images/Useravatar.svg";
import linguistic from "/public/images/popup-icons/linguistic-icon.png";
import Structure from "/public/images/popup-icons/structure-icon.png";
import ScoreIcon from "/public/images/popup-icons/Score-icon.png";
import DeleteIcon from "assets/images/images_new/delete-icon.svg";

const CONTENT = 0;
const FLUENCY = 1;
const PRONUNCIATION = 2;

const History = memo(function History(props) {
	const { questionData, activeTab, tabME, tabOTHERS, updateAttemptedState, refreshHistory = false } = props;

	const [questions, setQuestions] = useState([]);
	const [meTabLoaded, setMeTabLoaded] = useState(false);
	const [otherTabLoaded, setOtherTabLoaded] = useState(false);
	const [modal, setModal] = useState(false);
	const [qid, setQid] = useState(null);
	const [noRecords, setNoRecords] = useState(false);
	const [explanationModal, setExplanationModal] = useState(false);
	const [templateDetectorModalProps, setTemplateDetectorModalProps] = useState({});
	const [showDeleteModal, setShowDeleteModal] = useState(false);
	const [deletePayload, setDeletePayload] = useState({ e: null, q_id: null });

	useEffect(() => {
        // Call loadData() every time the tab becomes active
        if (activeTab || refreshHistory === true) {
            if ((tabME && activeTab === tabME) || (tabOTHERS && activeTab === tabOTHERS)) {
                loadData();
            }
        }
    }, [activeTab, refreshHistory]);

	const closeModalExplanation = () => {
		setExplanationModal(false);
	};


	const loadData = () => {
		let bodyFormData = new FormData();
		bodyFormData.set('question_id', questionData.id);
		bodyFormData.set('skip', 0); // we will only load 10 records.

		if (activeTab === tabOTHERS) {
			bodyFormData.set('all', 1);
		}

		API({
			method: 'POST',
			url: 'show/history',
			data: bodyFormData
		}).then(data => {
			if(data.status === 200) {
				if (data.data.data.length === 0) setNoRecords(true);
				else setNoRecords(false);
				
				// if (activeTab === tabME) {
				// 	setMeTabLoaded(true);
				// } else if (activeTab === tabOTHERS) {
				// 	setOtherTabLoaded(true);
				// }
				setQuestions(data.data.data);
			} else {
				setNoRecords(true);
			}
		});
	}

	const renderName = (user) => {
		let name = "-";
		if (user !== undefined && user.length > 0) {
			// name = user[0].first_name;
			const firstName = user[0]?.first_name || "";
		const lastName = user[0]?.last_name || "";
		name = `${firstName} ${lastName}`.trim();
		}

		return (
			<h3 className="result-user-name">{name ? name : 'LA user' }</h3>
		);
	}

	const renderImage = (user) => {
		let image_url = "";
		if (user !== undefined && user.length > 0) {
			if (user[0].image == null || user[0].image === "" || user[0].image === "null" || user[0].image === undefined) {
				image_url = "";
			} else {
				image_url = user[0].image;
			}
			// image_url = base + user[0].image;
		}		
		return (
		<div className="result-user-img">
			{image_url === "" ? (
			user[0].first_name ? (
				<div className="initials_circle">
				{user[0].first_name?.[0]?.toUpperCase() || ""}
				</div>
			) : (
				<img src={PlaceHolderUser} alt="LA" />
			)
			) : (
			<img src={`${import.meta.env.VITE_API_URL}${image_url}`} alt="LA" />
			)}
		</div>
		);
	}

	const renderAttemptedDate = (question) => {
		const month = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
		const d = new Date(question.local_date);
		const m = month[d.getMonth()];
		const dt = d.getDate();
		const yr = d.getFullYear();

		let hours = d.getHours();
	    const ampm = hours >= 12 ? 'PM' : 'AM';
	    hours = hours % 12 || 12;
	    const minutes = d.getMinutes();

		const parsed_date = `${m} ${dt}, ${yr} ${hours}:${minutes < 10 ? `0${minutes}` : minutes} ${ampm}`;
		return (
			<h3 className="result-user-date">{parsed_date}</h3>
		);
	}

	const renderScore = (score , subcategory_id) => {
		
		let sc = score.reduce((sum, key) => sum + parseFloat(key.score), 0);
		

		let out_of = score.reduce((sum, key) => sum + parseFloat(key.from), 0);
		// console.log("score", sc, "out of", out_of);
		
		if([1,2,3,4,21,22].includes(subcategory_id)) {
			sc = Math.round(score.reduce((sum, key) => sum + parseFloat(key.score), 0) / 3);
			out_of = Math.round(score.reduce((sum, key) => sum + parseFloat(key.from), 0) / 3);
		}
		return (
			<div className="result-score-wrapper">
				Score <span>{sc}/{out_of}</span>
			</div>
		);
	}

	const renderScoresOne = (question) => {
		return (
			<div className="result-info-audio">
				<div className="recorded-section h-100 w-100">
					<div className="recorded-content w-100 border-0 m-0">
						{/* <ul className="recorded-list">
							<li>Recorded Audio</li>
						</ul> */}
						<div className="recorded-audio-wrapper">
							<audio
								controls
								src={`${s3base}/ptedata/ptemedia/${question.file}`}
							></audio>
						</div>
					</div>
				</div>
			</div>
		);
	}

	const renderScoresTwo = (question) => {		
		return (
			<div className="result-info-audio">
				<div>
					<div className="custom-box m-0 p-0">
						<p className="gray-text bg-white">
							{ReactHtmlParser(question.answer)}
						</p>
					</div>
				</div>
			</div>
		);
	}

	const renderScoresThree = (question) => {	
		return (
					<div className="result-info-audio w-100 display-block">
				<div>
					<div className="custom-box m-0 p-0">
						<p className="gray-text bg-white">
							{ReactHtmlParser(question.html)}
						</p>
					</div>
				</div>
			</div>
				
		);
	}

	const renderResponseByCategory = (question) => {
		let score_response = null;
		if ([1, 2, 3, 4, 5, 21, 22].includes(question.question.subcategory_id)) {
			score_response = renderScoresOne(question);

		} else if ([11, 12, 20, 19, 16, 6, 7, 13].includes(question.question.subcategory_id)) {
			score_response = renderScoresTwo(question);
         
		}
		else if ([14,15,17,18].includes(question.question.subcategory_id)) {
			score_response = renderScoresThree(question);

		}else if([8,9,10].includes(question.question.subcategory_id)){
			score_response = renderScoresThree(question);
		
		}
		return score_response;
	}

	const resultClass = (question) => {
		let outer_class = "";
		if ([11, 12, 20, 19, 16, 6, 7, 13].includes(question.subcategory_id)) {
			outer_class = "user-result-history";
		}
		return outer_class;
	}

	const showScore = (e, q_id) => {
		setQid(q_id);
		setModal(true);
	}

	const modalToggle = () => {
		setModal(!modal);
	}

	const showHistoryFunc = () => {
	let arr = questions.map((v) => {
		if (qid === v.id) {
			return v.score;
		}
	});
	
	let arr1 = arr.filter((va) => {
		if(typeof va === "object") {
			return va;
		}
	})[0];

	let totalScore = 0;
	let totalFrom = 0;

	const rows = arr1.map((v) => {
		totalScore += v.score;
		totalFrom += v.from;

		// status logic
		const percent = v.from ? (v.score / v.from) * 100 : 0;
		let status = "Average";
		let badgeClass = "badge-warning";
		
		if (percent >= 85) {
		status = "Perfect";
		badgeClass = "badge-success";
		} else if (percent >= 70) {
		status = "Good";
		badgeClass = "badge-success";
		}

		const iconSrc = getIconByType(v.type) || "/icons/default.svg";

		// remarks list
		const remarksList = `<li class="mx-3">${v.remarks}</li>`;

		return `
		<div class="performance-item">
			<div class="item-header">
			<div class="item-title">
				<img src="${iconSrc}" alt="${remarks(v.type)}" style="max-height:30px;" />
				<span>${remarks(v.type)}</span>
			</div>

			<span class="score">${v.score}/${v.from}</span>
			</div>

			<ul>
			${remarksList}
			</ul>
		</div>
		`;
	});

	// total row (for specific question types)
	if ([1, 2, 3, 4, 21, 22].includes(questions[0].question.subcategory_id)) {
      totalFrom = totalFrom / arr1.length;
	  totalScore = totalScore / arr1.length;
      rows.push(`
        <div class="performance-item total">
          <div class="item-header">
            <div class="item-title">
              <span>Total</span>
            </div>
            <span class="score fw-bold">${Math.round(totalScore)}/${totalFrom}</span>
          </div>
        </div>
      `);
    } else {
      rows.push(`
        <div class="performance-item total">
          <div class="item-header">
            <div class="item-title">
              <span>Total</span>
            </div>
            <span class="score fw-bold">${totalScore}/${totalFrom}</span>
          </div>
        </div>
      `);
    }
	// if ([6, 7, 13].includes(questions[0].question.subcategory_id)) {}

	return rows;
	};

	const getIconByType = (type) => {
		switch (type) {
		case 0:
			return Content;

		case 1:
			return Fluency;

		case 2:
			return Pronunciation;

		case 3:
			return ScoreIcon;

		case 4:
			return Grammar;

		case 5:
			return FormIcon;

		case 6:
			return Vocabulary;

		case 7:
			return BarFrequency;

		case 8:
			return linguistic;

		case 9:
			return Structure;

		default:
			return "";
		}
	};

	const remarks = (type) => {
		const remarksArray = [
			"Content", "Fluency", "Pronunciation", "Score",
			"Grammar", "Form", "Vocabulary", "Spelling",
			"Linguistic range", "Structure"
		];

		return remarksArray[type];
	}

	const deleteScore = (e, q_id) => {
		setDeletePayload({ e, q_id });
  		setShowDeleteModal(true);
		// confirmAlert({
		// 	title: '',
		// 	message: 'Are you sure you want to delete this record?',
		// 	buttons: [
		// 		{
		// 			label: 'Yes',
		// 			onClick: () => deleteScoreApi(e, q_id)
		// 		},
		// 		{
		// 			label: 'No'
		// 		}
		// 	]
		// });
	}

	const handleClose = () => {
		setShowDeleteModal(false);
		setDeletePayload({ e: null, q_id: null });
	};

	const handleConfirmDelete = () => {
		deleteScoreApi(deletePayload.e, deletePayload.q_id);
		handleClose();
	};
	

	const deleteScoreApi = async (e, id) => {
		let bodyFormData = {
			id,
			question_id: questionData
		};

		let res = null;
		try {
			res = await API({
				method: 'Delete',
				url: 'delete/question/responseNew',
				data: bodyFormData
			});
		} catch(error) {
			console.log("unable to delete");
		};

		if(res) {
			if (res.status === 200) {
				let data = questions.filter((val)=> {
					if(parseInt(val.id) !== parseInt(id)) {
						return val;
					}
				});
				setQuestions(data);
				updateAttemptedState();
				store.dispatch(setAlert({
					flag: true,
					type: 1,
					message: res.data.message
				}));
			}
		}
	}

	const renderNoRecords = () => {
		return (
			<div className="no-data visibility-visible">
				No data yet.
			</div>
		);
	}

	const getAverageScore = (question) => {
		const { score } = question;
		let average_score = 0;
		let out_of = 0;
		for (let i = 0; i < score.length; i++) {
			average_score += score[i].score;
			out_of += score[i].from;
		}
		
		return {
			score: average_score / score.length,
			out_of: out_of / score.length
		};
	}

	const scoreObject = (score) => {
		return {
			score: score.score,
			out_of: score.from,
		};
	}

	const updateScorePopupData = (scores, data) => {

		if (scores.length > 0) {
			for(let i = 0; i < scores.length; i++) {
				let score = scores[i];
				
				switch (score.type) {
					case CONTENT:
						data.contentScore = scoreObject(score);
						break;
					case FLUENCY:
						data.fluencyScore = scoreObject(score);
						break;
					case PRONUNCIATION:
						data.pronunciationScore = scoreObject(score);
						break;
					default:
						break;
				}
			}
		}

		return data;
	}

	return (
    <>
      <Modal show={modal} centered size="lg" className="score-popup">
        <Modal.Header className="d-flex">
          <Modal.Title className="text-translation popup_heading m-0">
            Score with remarks
          </Modal.Title>

          <Button
            variant="link"
            className="modalClose-Btn p-0"
            onClick={modalToggle}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              width="24"
              height="24"
            >
              <path
                d="M18 6L6 18M6 6l12 12"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </Button>
        </Modal.Header>
        <Modal.Body className="pb-0">
          {/* <Table className="w-100">
            <tbody>
              <tr>
                <th>Component</th>
                <th>Score</th>
                <th>Remarks</th>
              </tr>
            </tbody>
          </Table> */}
              {modal &&
                showHistoryFunc().map((v) => {
                  return ReactHtmlParser(v);
                })}
        </Modal.Body>
        <Modal.Footer className="justify-content-start">
          <Button
            color="secondary"
            className="modalCloseBtn"
            onClick={modalToggle}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showDeleteModal}
        onHide={handleClose}
        centered
        backdrop="static"
		size="md"
      >
        <Modal.Header className="d-flex">
          <Modal.Title className="text-translation popup_heading m-0 gap-2">
			<div className="modal-header-img">
				<img src={DeleteIcon} alt="multi-languages" />
			</div>
            Delete This Record
          </Modal.Title>

          <Button
            variant="link"
            className="modalClose-Btn p-0"
            onClick={handleClose}
			style={{top: "16px"}}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              width="24"
              height="24"
            >
              <path
                d="M18 6L6 18M6 6l12 12"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </Button>
        </Modal.Header>

        {/* Body Text */}
        <Modal.Body className="">
          <p className="mb-1">Are you sure you want to delete this record?</p>
        </Modal.Body>
          <div className="d-flex justify-content-start gap-3">
			<Modal.Footer>
            <button className="recording-buttons" onClick={handleConfirmDelete}>
              Yes
            </button>
            <button className="recording-buttons" onClick={handleClose}>
              No
            </button>
			</Modal.Footer>
          </div>
      </Modal>

      {noRecords && renderNoRecords()}

      {explanationModal && (
        <TemplateDetectorModal
          isOpen={explanationModal}
          {...templateDetectorModalProps}
          closeModal={closeModalExplanation}
        />
      )}

      {questions.map((question, i) => {
        const type = question?.practice_question_template_detected?.type;
        const sentence =
          question?.practice_question_template_detected?.sentence;

        const average = getAverageScore(question);

        const averageScore = average.score;
        const averageOutOf = average.out_of;

        let score_popup_data = {
          remarks: question?.score[0].remarks,
          overallScore: {
            score: averageScore.toFixed(0),
            out_of: averageOutOf.toFixed(0),
          },
        };

        score_popup_data = updateScorePopupData(
          question.score,
          score_popup_data
        );

        const templateDetectorModalProps = {
          title: type === "repeat" || type === "common" ? sentence : "",
          template_type: type,
          common_sentence: type === "common" ? sentence : "",
          data: score_popup_data,
        };

        return (
          <div className="result-info-outer visibility-visible" key={i}>
			  {[1, 2, 3, 4, 5, 21, 22].includes(question.question.subcategory_id) ? (
				<div className={`result-info-row d-flex flex-wrap align-items-start align-items-xl-center justify-content-between ${resultClass(question.question)}`} >
              <div className="re-user-info">
                <div className="result-info-wrapper">
                  {renderImage(question.user)}
                  <div className="result-user-info">
                    {renderName(question.user)}
                    {renderAttemptedDate(question)}
                  </div>
                </div>
              </div>
              {/* {renderResponseByCategory(question)} */}
			  <div className="result-info-audio result-info-audio-speaking">
				<div className="recorded-section h-100 w-100">
					<div className="recorded-content w-100 border-0 m-0">
						<ul className="recorded-list">
							<li>Recorded Audio</li>
						</ul>
						<div className="recorded-audio-wrapper m-0">
							<WaveformAudioPlayer key={i} src={`${s3base}/ptedata/ptemedia/${question.file}`} />
						</div>
					</div>
				</div>
			</div>
            <div className="result-actions d-flex align-items-center">
              {renderScore(question.score , question.question.subcategory_id)}
              <div className="right-btns">
                {store.getState().user.id === question.user_id && (
                  <button
                    // href="javascript:void(0);"
                    className="outline-btn outline-btn-danger"
                    onClick={(e) => deleteScore(e, question.id)}
                  >
                    Delete
                  </button>
                )}

                <button
                  // href="javascript:void(0);"
                  className="submit-btns"
                  onClick={(e) => {
                    if (question?.type == 3 || question?.type == 4) {
                      if (type === "repeat" || type === "common") {
                        setTemplateDetectorModalProps(
                          templateDetectorModalProps
                        );
                        setExplanationModal(true);
                      } else {
                        showScore(e, question.id);
                      }
                    } else {
                      showScore(e, question.id);
                    }
                  }}
                >
                  View
                </button>
              </div>
            </div>
            </div>
			  ):(
				<>
            <div
              className={`result-info-row ${resultClass(question.question)}`}
            >
              <div className="user-section w-100 w-md-50">
                <div className="result-info-wrapper">
                  {renderImage(question.user)}
                  <div className="result-user-info">
                    {renderName(question.user)}
                    {renderAttemptedDate(question)}
                  </div>
                </div>
              </div>
              {renderResponseByCategory(question)}
            </div>
            <div className="d-flex align-items-center mt-3">
              {renderScore(question.score , question.question.subcategory_id)}
              <div className="right-btns">
                {store.getState().user.id === question.user_id && (
                  <button
                    // href="javascript:void(0);"
                    className="outline-btn outline-btn-danger"
                    onClick={(e) => deleteScore(e, question.id)}
                  >
                    Delete
                  </button>
                )}

                <button
                  // href="javascript:void(0);"
                  className="submit-btns"
                  onClick={(e) => {
                    if (question?.type == 3 || question?.type == 4) {
                      if (type === "repeat" || type === "common") {
                        setTemplateDetectorModalProps(
                          templateDetectorModalProps
                        );
                        setExplanationModal(true);
                      } else {
                        showScore(e, question.id);
                      }
                    } else {
                      showScore(e, question.id);
                    }
                  }}
                >
                  View
                </button>
              </div>
            </div>
				</>
			  )}
          </div>
        );
      })}
    </>
  );
});
export default History;